import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import $ from 'jquery'
import Header from '@/components/common/Header.vue'
import SpMenu from '@/components/common/SpMenu.vue'
import InformationPopup from '@/components/common/Popup/InformationPopup.vue'
import Notifications from '@/components/common/Notifications.vue'
import { useInitDataStore } from '@/stores/initDataStore'
import { usePresentStore } from '@/stores/presentStore'
import { useGpvStore } from '@/stores/gpvStore'
import { useNewsHistoryStore } from '@/stores/newsStore'
import { useGlobalStore } from '@/stores/globalStore'
import { useWeatherWaringStore } from '@/stores/weatherWarningStore'
import { check as notificationCheck } from '@/composables/use-notifications'
import gtag from '@/lib/gtag'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const FETCH_INTERVAL = 60 * 1000 // 1min
const globalStore = useGlobalStore()
const initDataStore = useInitDataStore()
const presentStore = usePresentStore()
const gpvStore = useGpvStore()
const newsStore = useNewsHistoryStore()
const weatherWarningStore = useWeatherWaringStore()
const route = useRoute()
const router = useRouter()
const fetchPresent = () => {
  const stationList = initDataStore.initData.stationList

  if (stationList) {
    presentStore.fetchAll(stationList)
  }
}
const setFavicon = () => {
  const $favicon = $('link[rel="icon"]')
  const faviconUrl = initDataStore.initData.systemInfo.favicon

  $favicon.attr('href', faviconUrl)
}

const setTitle = () => {
  const $title = $('title')

  $title.text(initDataStore.initData.systemInfo.title as string)
}

const rootClass = computed(() => {
  const spModeClass = globalStore.isSP ? 'sp' : ''
  const ichinomiyaClass = globalStore.isIchinomiya ? 'ichinomiya' : ''

  return [spModeClass, ichinomiyaClass]
})

const loading = computed(() => {
  return initDataStore.loading || gpvStore.loading || presentStore.loading
})

const fetchWeatherWarning = () => {
  const areaList = initDataStore.initData.definitionInfo.alerts?.common?.areaInfo || []

  weatherWarningStore.fetch(areaList)
}

const fetchCurrent = () => {
  gpvStore.fetchTime()
  fetchPresent()
  newsStore.fetch()
  notificationCheck()
  fetchWeatherWarning()
}

initDataStore.fetch().then(() => {
  const trackingId = initDataStore.initData.systemInfo.analytics

  gtag.init(trackingId, router)
  fetchCurrent()
})

watch(initDataStore, () => {
  fetchPresent()
  setFavicon()
  setTitle()

  if (route.path === '/' && initDataStore.initData.systemInfo.defaultPage) {
    router.replace(initDataStore.initData.systemInfo.defaultPage)
  }
})

setInterval(() => {
  if (!globalStore.autoUpdateEnable) {
    return
  }

  fetchCurrent()
}, FETCH_INTERVAL)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(rootClass), "root viewmode-light"])
  }, [
    (!_unref(loading))
      ? (_openBlock(), _createBlock(Header, { key: 0 }))
      : _createCommentVNode("", true),
    (!_unref(loading))
      ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(SpMenu),
    (!_unref(loading))
      ? (_openBlock(), _createBlock(InformationPopup, { key: 2 }))
      : _createCommentVNode("", true),
    _createVNode(Notifications)
  ], 2))
}
}

})